import get from 'lodash/get';
import * as types from '../actionTypes/AccountDetailsActionTypes';
import * as addressTypes from '../actionTypes/AddressActionTypes';

// TDOD: cleanup this pls
function AccountDetailsReducer(state = { profile: {} }, action = {}) {
    switch (action.type) {
        case types.PROFILE: {
            return { ...state, errorProfile: null, isLoading: true, isSuccess: false };
        }
        case types.GET_PROFILE_SUCCESS: {
            return { ...state, ...action, isLoading: false, isSuccess: true };
        }
        case addressTypes.POST_ADDRESSES_SUCCESS: {
            const newState = { ...state };
            const { response } = action.payload;
            if (response.isDefault) {
                newState.defaultAddress = response;
            }
            return newState;
        }
        case addressTypes.UPDATE_ADDRESSES_SUCCESS: {
            const newState = { ...state };
            const { response } = action.payload;
            if (get(response, 'params.isDefault')) {
                newState.defaultAddress = response.params;
            }
            return newState;
        }
        case types.GET_PROFILE_ERROR: {
            const errorProfile = action.errorResponse;
            return {
                ...state,
                errorProfile,
                profile: { isLoading: false, isSuccess: false },
                isLoading: false,
                isSuccess: false,
            };
        }
        case types.UPDATE_PROFILE: {
            const newProfile = { ...state.profile };
            newProfile.isSuccess = false;
            newProfile.isLoading = true;
            newProfile.requestFrom = null;
            delete newProfile.error;
            return { ...state, profile: newProfile };
        }
        case types.UPDATE_PROFILE_SUCCESS: {
            const newProfile = { ...state.profile, ...action.payload.profile };
            newProfile.isLoading = action.payload.isLoading;
            newProfile.isSuccess = action.payload.isSuccess;
            newProfile.requestFrom = action.payload.requestFrom;
            return { ...state, profile: newProfile };
        }
        case types.UPDATE_PROFILE_ERROR: {
            const newProfile = { ...state.profile };
            newProfile.requestFrom = action.payload.requestFrom;
            newProfile.isLoading = action.payload.isLoading;
            newProfile.isSuccess = action.payload.isSuccess;
            newProfile.error = action.payload.error;
            return { ...state, profile: newProfile };
        }
        case types.SUBMIT_PROMOTIONAL_DETAILS_SUCCESS: {
            return { ...state, promotionalDetails: { showSuccessModal: true } };
        }
        case types.CLOSE_PROMOTIONAL_DETAILS_MODAL: {
            return { ...state, promotionalDetails: { showSuccessModal: false } };
        }
        case types.SUBMIT_PROMOTIONAL_DETAILS_FAILED: {
            const { errorResponse } = action;
            return { ...state, promotionalDetails: { errorResponse, showSuccessModal: false } };
        }
        default:
            return state;
    }
}

AccountDetailsReducer.reducerName = 'accountDetails';
export default AccountDetailsReducer;
